import Styles from '../../styles/Home.module.css'
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

import InstagramIcon from '@mui/icons-material/Instagram';
import CheckIcon from '@mui/icons-material/Check';
import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import MenuExample from '../../images/home/menu_example.webp'

import SaveMoneyImg from '../../images/home/home_save_money.webp'
import SaveTimeImg from '../../images/home/home_save_time.webp'
import GetCustomersImg from '../../images/home/home_get_customers.webp'

import SaveMoneyImgBig from '../../images/home/home_save_money_big.webp'
import SaveTimeImgBig from '../../images/home/home_save_time_big.webp'
import CustomizeImgBig from '../../images/home/home_customize_big.webp'

import CreateOffersImgFeature from '../../images/home/create_offers_feature.webp'
import CustomizeImgFeature from '../../images/home/customize_feature.webp'
import FastLoadingImgFeature from '../../images/home/fast_loading_feature.webp'
import ManageProductImgFeature from '../../images/home/manage_products_feature.webp'
import ShareImgFeature from '../../images/home/share_feature.webp'
import WhatsappImgFeature from '../../images/home/whatsapp_feature.webp'
import Menu from './Menu';
import { useEffect } from 'react';

function Home() {

    const navigate = useNavigate()

    const contactByWpp = () => {
        // Create the WhatsApp link
        const contactNumber = '1524008826'
        const encodedMessage = encodeURIComponent('Hola! Me gustaría usar Tookeat para mi negocio y quisiera mas información');
        const link = `https://wa.me/${contactNumber}?text=${encodedMessage}`;

        // Open the WhatsApp app with the message ready to be sent
        window.open(link);
    }

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Fab color='success' style={{ position: 'fixed', right: '20px', bottom: '20px', }}
                onClick={() => contactByWpp()}>
                <WhatsAppIcon />
            </Fab>
            <header>
                <Menu />

                <div className={Styles.mainBanner}>

                    <Stack className={Styles.mainBannerContent} spacing={3} >
                        <Typography component='h1' fontFamily={'verdana'}>Crea tu menú online y recibe pedidos por Whatsapp</Typography>

                        <div className={Styles.mainBannerText}>
                            <Typography variant='h5' fontWeight={500}>
                                Si no <b>vendes online</b>, estás perdiendo el <b>30%</b> de tus clientes potenciales
                                <br />
                                <span style={{backgroundColor: "rgba(200,100,200,0.75)"}}>Crea tu menú <b>gratis</b> en minutos y sin pagar comisiones!</span>
                            </Typography>
                        </div>

                        <Stack direction='row' flexWrap='wrap' alignSelf='center' justifyContent='center' alignItems='center'>
                            <button className={Styles.mainCta} onClick={() => navigate('/admin/signup')}>Crear mi cuenta gratis ahora</button>
                            <button className={Styles.demoButton} onClick={() => window.open('/parrilladonangel', '_blank')}>Ver Demo</button>
                        </Stack>
                    </Stack>

                    <img alt='' src={MenuExample} className={Styles.mainBannerImg}></img>

                </div>

            </header>

            <main className={Styles.container}>

                <div className={Styles.textBanner}>
                    <Typography variant='h6'>TookEat es la mejor plataforma para llevar tu negocio gastronómico al siguiente nivel.
                        Consigue mas clientes ofreciendo un menu interactivo para delivery, takeaway o incluso para comer en el lugar</Typography>
                </div>

                <div style={{ marginBottom: '40px' }}>

                    <div className={Styles.cardsContainer}>
                        <div className={Styles.card}>
                            <img alt='' src={SaveMoneyImg} className={Styles.imgFluid}></img>
                            <Typography variant='h6'>Ahorra hasta el 90% de tus gastos en comisiones en aplicaciones delivery</Typography>
                        </div>
                        <div className={Styles.card}>
                            <img alt='' src={GetCustomersImg} className={Styles.imgFluid}></img>
                            <Typography variant='h6'>Consigue mas clientes simplificando la forma en la que hacen pedidos</Typography>
                        </div>
                        <div className={Styles.card}>
                            <img alt='' src={SaveTimeImg} className={Styles.imgFluid}></img>
                            <Typography variant='h6'>Muy simple de implementar y te asesoramos si lo necesitas</Typography>
                        </div>
                    </div>
                </div>

                <div className={Styles.textBanner}>
                    <Typography variant='h6'>No pagues comisiones por clientes que ya conseguiste! Tus clientes pueden hacer sus pedidos por Tookeat en vez de usar otra aplicación
                        de delivery resultando en que no tengas que pagar comisiones en todos los pedidos!</Typography>
                </div>

                <div className={Styles.bigCard}>
                    <img alt='' src={SaveMoneyImgBig} className={Styles.imgFluid}></img>

                    <Stack spacing={2}>
                        <Typography variant='h5' fontWeight={600} textAlign='center'>
                            Menos comisiones y más ganancias
                        </Typography>

                        <Typography>Con TookEat, te librarás de los costos excesivos asociados a las aplicaciones de delivery.
                            Puedes usar la versión gratuita o usar una versión completa por lo que valen dos pizzas!</Typography>

                        <button className={Styles.generalCta} onClick={() => navigate('/admin/signup')}>Crear mi cuenta gratis</button>
                    </Stack>

                </div>

                <div className={Styles.bigCard}>

                    <Stack spacing={2}>
                        <Typography variant='h5' fontWeight={600} textAlign='center'>
                            Gestiona tus productos y pedidos fácilmente
                        </Typography>

                        <Typography>Administra tus productos de manera intuitiva y sencilla, actualizando tu menú en tiempo real.
                            Nosotros nos encargamos de que los pedidos ya te lleguen armados a WhatsApp asi puedes encargarte de lo que importa</Typography>
                    </Stack>

                    <img alt='' src={SaveTimeImgBig} className={Styles.imgFluid}></img>
                </div>

                <div className={Styles.bigCard}>
                    <img alt='' src={CustomizeImgBig} className={Styles.imgFluid}></img>

                    <Stack spacing={2}>
                        <Typography variant='h5' fontWeight={600} textAlign='center'>
                            El impulso extra que necesita tu negocio
                        </Typography>

                        <Typography>El 30% de los clientes realizan sus pedidos online ¿Que estás esperando? Incluso sin contar con un servicio de delivery, puedes ofrecer Takeaway
                            y generar un flujo extra de clientes y dinero a tu negocio</Typography>

                        <button className={Styles.generalCta} onClick={() => navigate('/admin/signup')}>Registrarme ahora</button>
                    </Stack>

                </div>

                <div className={Styles.cardsContainer}>
                    <div className={Styles.featureCard}>
                        <img src={WhatsappImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Recibe pedidos por WhatsApp</Typography>
                    </div>
                    <div className={Styles.featureCard}>
                        <img src={CreateOffersImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Crea promociones</Typography>
                    </div>
                    <div className={Styles.featureCard}>
                        <img src={ManageProductImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Gestiona tus productos</Typography>
                    </div>
                    <div className={Styles.featureCard}>
                        <img src={CustomizeImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Personaliza tu menú</Typography>
                    </div>
                    <div className={Styles.featureCard}>
                        <img src={FastLoadingImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Carga rápida</Typography>
                    </div>
                    <div className={Styles.featureCard}>
                        <img src={ShareImgFeature} className={Styles.imgFluid} />
                        <Typography variant='h6' fontWeight={500}>Comparte tu menú en todos lados</Typography>
                    </div>
                </div>

                <Stack spacing={3} alignItems='center' className={Styles.plansContainer}>
                    <Stack direction='row' spacing={3}>
                        <Stack className={Styles.planContainer} spacing={2}>
                            <Typography variant='h5' fontWeight={500} textAlign='center'>Plan gratuito</Typography>
                            <Stack spacing={1}>
                                <Typography><CheckIcon sx={{ color: 'rgb(230,230,0)' }} />Tienda personalizable</Typography>
                                <Typography><CheckIcon sx={{ color: 'rgb(230,230,0)' }} />Funciones administrativas <b>basicas</b></Typography>
                                <Typography><CheckIcon sx={{ color: 'rgb(230,230,0)' }} />Hasta <b>10</b> Productos</Typography>
                                <Typography><CheckIcon sx={{ color: 'rgb(230,230,0)' }} />Hasta <b>2</b> extras por producto</Typography>
                                <Typography><CheckIcon color='success' />Muchas mas funciones</Typography>
                            </Stack>
                        </Stack>
                        <Stack className={Styles.planContainer} spacing={2}>
                            <Typography variant='h5' fontWeight={500} textAlign='center'>Plan PRO</Typography>
                            <Stack spacing={1}>
                                <Typography><CheckIcon color='success' />Tienda personalizable</Typography>
                                <Typography><CheckIcon color='success' />Funciones administrativas <b>avanzadas</b></Typography>
                                <Typography><CheckIcon color='success' />Productos <b>ilimitados</b></Typography>
                                <Typography><CheckIcon color='success' />Extras <b>ilimitados</b> por producto</Typography>
                                <Typography><CheckIcon color='success' />Muchas mas funciones</Typography>
                            </Stack>
                        </Stack>
                    </Stack>

                    <button className={Styles.generalCta} onClick={() => navigate('/plans')}>Comparar planes</button>
                </Stack>

                <div className={Styles.whyChooseUs}>
                    <Typography variant='h5' fontWeight={500}>
                        ¿Por qué deberías elegirnos?
                    </Typography>
                    <br />
                    <Typography>En TookEat, entendemos tus desafíos y queremos ofrecerte la respuesta que necesitas. Nuestra plataforma intuitiva está diseñada para ayudarte a superar los obstáculos más comunes en la industria de la gastronomía. Con TookEat, podrás maximizar tus ganancias al evitar las altas comisiones de las aplicaciones de delivery y tener el control total sobre tus pedidos online.</Typography>
                    <br />
                    <Typography>Simplifica la gestión de tu menú, personaliza la experiencia de tus clientes y destácate de la competencia. Nos enorgullece ofrecer un servicio de atención al cliente excepcional, brindándote el soporte y la asistencia que necesitas en cada paso del camino. No pierdas más tiempo y dinero en soluciones que no se adaptan a tus necesidades. Con TookEat, te damos la libertad y flexibilidad que necesitas para destacarte en la industria gastronómica.</Typography>
                    <br />
                    <button className={Styles.generalCta} onClick={() => navigate('/admin/signup')} >Registra tu negocio gratis ahora</button>
                </div>

            </main>

            <footer className={Styles.footer}>

                <Typography variant='h5'>
                    Contactanos
                </Typography>

                <Stack justifyContent='center' alignItems='center' sx={{ p: 2 }}>

                    <Typography >¿Necesitas más información? Contáctanos ahora y vamos a estar encantados de resolver todas tus dudas.</Typography>

                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography>tookeat.contacto@gmail.com</Typography>
                        <IconButton sx={{ color: 'white' }} onClick={() => window.open('https://www.instagram.com/tookeat')}>
                            <InstagramIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </Stack>
                </Stack>

                <Typography variant='body2'>
                    Tookeat.com | Todos los derechos reservados
                </Typography>

            </footer>
        </>
    )

}


export default Home